import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

import Router from './router';

// global styles
import './assets/styles/main.scss';

// Prefetch header images before React initialization
import { prefetchImages } from './utils/prefetch-images.util';
import { app } from './config';

// Prefetch all header background images
prefetchImages(app.header.backgroundImages);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={Router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
